$(document).ready(function(){
 if (navigator.userAgent.indexOf('EcoModernEssentials-PROD') > -1) {
   $('body').addClass("EcoModernEssentials-PROD");   
   $(".shopify-section.section-header.custom-site--header-mobile-none").css('display','none');
   $(".shopify-section.shopify-section-group-footer-group.custom-site--footer-mobile-none").css('display','none');
   $(".shopify-section.shopify-section-group-header-group.announcement-bar-section").css('display','none');
   $(".page-shipping #MainContent a").css("color","#5e5c5c").css("border","0").css("text-decoration","none").css("pointer-events","none");
   $(".page-faq #MainContent a").css("color","#5e5c5c").css("border","0").css("text-decoration","none").css("pointer-events","none");
   $(".page-klarna-faq-mobile #MainContent a").css("color","#5e5c5c").css("border","0").css("text-decoration","none").css("pointer-events","none");
   $(".page-essential-oils-afterpay-buy-now-amp-pay-later #MainContent a").css("color","#5e5c5c").css("border","0").css("text-decoration","none").css("pointer-events","none");

    $('body').css("padding-top","0px");
    $('.template-article .shg-c.shg-btn-wrapper').css('display','none');

    setInterval(function () { 
      $('body #reamazejs-container').css('display','none');
      $('body #wishlisthero-floating-launcher-container').css('display','none');
      $('div[data-wzb=InformationBar]').css('display','none');
      $(".__seguno-banner-container").css('display','none!important');
      $(".EcoModernEssentials-PROD .responsive-wrapper").css('display','none!important');
      //$("body .needsclick.kl-private-reset-css-Xuajs1").css('display','none!important');
      $(".EcoModernEssentials-PROD #dynamic-react-root + div>button.kl-private-reset-css-Xuajs1").css('display','none!important');
    }, 1000);

    
    
    $(".shopify-section.section-newsletter.custom-site--newsletter-mobile-none").css('display','none');
    $(".custom-cancel-button-mobile-hide").css('display','none');

    $(".template-article .shopify-section.section-featured-collection").css('display','none');
    $(".template-article .shg-btn-wrapper").css('display','none');
    $(".template-article .shg-product-atc-btn-wrapper").css('display','none');
    $(".template-article .sharing.social-links").css('display','none');

    $(".template-article .other-products.other-products--articles .other-products__label").css('display','none');
  
    $(".my-rewards-mobileapp-display").css('display','block!important;');
  
    $(".account-page-wrapper").css('display','none');
    $("#shopify-section-account-subscription-custom-information").css('display','none');

    $(".page-essential-oils-afterpay-buy-now-amp-pay-later .shg-product-atc-btn-wrapper").css('display','none');
    $(".page-essential-oils-afterpay-buy-now-amp-pay-later .shg-btn-wrapper").css('display','none');

    $(".page-account .one-click-social-login-buttons").css('display','none');

    $(".template-article #page-content .shg-product").css('display','none');
    //$(".template-article #page-content .shg-align-center .shogun-heading-component").css('display','none');

    $(".template-article #page-content .other-products.other-products--articles").css('display','none');

    $(".__seguno-banner-container.__seguno-banner-container-body-target-false.__seguno-show-animation.__seguno-banner-size-small").css('display','none');

    $(".template-article .article a").css("pointer-events","none");

    $(".test-search .section-search-template .search-form").css("margin-bottom","30px");

    $(".template-article #page-content a").css("color","#5e5c5c").css("border","0").css("text-decoration","none").css("pointer-events","none");

    $(".page-essential-oils-afterpay-buy-now-amp-pay-later #page-content a").css("color","#5e5c5c").css("border","0").css("text-decoration","none").css("pointer-events","none");

    $(".page-klarna-faq-mobile #page-content a").css("color","#5e5c5c").css("border","0").css("text-decoration","none").css("pointer-events","none");

    $(".page-shipping #page-content a, .page-faq #page-content a, .page-shipping-amp-delivery-eco-modern-essentials #page-content a").css("color","#5e5c5c").css("border","0").css("text-decoration","none").css("pointer-events","none");

    $(".page-klarna-faq-mobile .featured-logo-wrapper:not(.swiper) .swiper-slide").css("width","calc(100%/2)");

    $(".template-article .breadcrum-wrraper").css("justify-content","center");
    $(".template-blog .breadcrum-wrraper").css("justify-content","center");

    $(".template-article #page-content .breadcrumbs-list__item a").css("pointer-events","all");

    $(".template-article #page-content .mobile-breadcrumbs-only").css("display","inline-block");
    $(".template-blog #page-content .mobile-breadcrumbs-only").css("display","inline-block");

    $(".template-article #page-content .desktop-breadcrumbs-only").css("display","none");
    $(".template-blog #page-content .desktop-breadcrumbs-only").css("display","none");
    
    
 }else{
   			  $(".shopify-section.section-header.custom-site--header-mobile-none").css('display','block');
              $(".shopify-section.shopify-section-group-footer-group.custom-site--footer-mobile-none").css('display','block');
              $(".shopify-section.shopify-section-group-header-group.announcement-bar-section").css('display','block');
   
 }
  
});
